import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkExpiration'
})
export class CheckExpirationPipe implements PipeTransform {

  transform(expirationDate: Date): any {
    const today = new Date();
    return expirationDate <= today;
  }

}
